// config/AppVersion.js
export const appVersion = 'v1.0.39'; // Versão do aplicativo - Adicionado cálculo de saldo orçamentário
